import styled from 'styled-components'

export const StyledSvg = styled.svg`
  &:hover {
    path {
      stroke: #3249d7;
    }
  }
`
export const FillSvg = styled.svg`
  fill: #000;

  &:hover {
    fill: #3249d7;
  }
`
